export const reloadCardProgram = ["Reloadable", "Non-Reloadable"];
export const debitOrPrepaid = ["Prepaid", "Debit"];
export const programTypePrepaid = [
  { label: "Consumer Prepaid", value: 0 },
  { label: "Commercial Prepaid", value: 1 },
];
export const programTypeDebit = [
  { label: "Payroll cards to transfer salaries", value: 0 },
  { label: "General Purpose", value: 1 },
  { label: "Other", value: 2 },
];
export const credit_programType = [
  "Consumer",
  "Corporate",
  "Small Medium Business",
];
export const generalEntityType = [
  { label: "i2c Inc.", value: 0 },
  { label: "Other", value: 1 },
];
export const commercialPrepaid = [
  {
    label: "Pay for employee business travel and entertainment expenses",
    value: 0,
  },
  { label: "Pay for general commercial purchases", value: 1 },
  { label: "Distribute/Disburse funds to beneficiaries", value: 2 },
  { label: "Pay incentives to permanent employees", value: 3 },
  { label: "Other", value: 4 },
];
export const consumerPrepaid = [
  {
    label: "General purpose issued to consumers for general spending",
    value: 0,
  },
  { label: "Gift cards for consumer gift giving", value: 1 },
  {
    label: "Payroll cards to transfer salaries through a pre-paid card",
    value: 2,
  },
  { label: "Travel cards to facilitate travelling consumers", value: 3 },
  { label: "Instant issue cards", value: 4 },
  { label: "Incentive cards to pay incentive to contractors", value: 5 },
  { label: "Closed loop – for use at internal locations only", value: 6 },
  { label: "Other", value: 7 },
];
export const setupType = ["New Program", "Migration"];
export const migrationType = ["Bank Migration", "Processor Migration"];
export const dataMigInfo = [
  { label: "Current Processor", value: 0 },
  { label: "Issuing Bank", value: 1 },
  { label: "Program Manager", value: 2 },
  { label: "Other", value: 3 },
];
export const dataMigAttr = [
  { label: "Card Account Balances", value: 0 },
  { label: "User IDs (for web access)", value: 1 },
  { label: "Cardholder's Bank Account Details (for ACH transfer)", value: 2 },
  { label: "Transaction History", value: 3 },
  { label: "Other", value: 4 },
];
export const credit_dataMigAttr = [
  { label: "Card Account Balances", value: 0 },
  { label: "User IDs (for web access) ", value: 1 },
  { label: "Cardholder's Bank Account Details(for ACH transfer)", value: 2 },
  { label: "Allocated Limits", value: 3 },
  { label: "Transaction History", value: 4 },
  { label: "Payment History", value: 5 },
  { label: "Card Status History", value: 6 },
  { label: "Statement Statistics", value: 7 },
  { label: "Delinquency Details (month on month breakdown)", value: 8 },
  { label: "Charged-off Accounts Details", value: 9 },
  { label: "Loyalty/Rewards Points", value: 10 },
  { label: "APR Details", value: 11 },
  { label: "Delinquency Actions", value: 12 },
  { label: "Bureau Reporting Details", value: 13 },
  { label: "Disputes History", value: 14 },
  { label: "User Alerts", value: 15 },
  { label: "Other", value: 16 },
];
export const currencies = ["PKR", "USD", "CAD"];
